export default __webpack_public_path__ + "static/media/skull.aad83f11.png";